import { render, staticRenderFns } from "./InteractionMinimumTime.vue?vue&type=template&id=640bf49a&scoped=true"
import script from "./InteractionMinimumTime.vue?vue&type=script&lang=js"
export * from "./InteractionMinimumTime.vue?vue&type=script&lang=js"
import style0 from "./InteractionMinimumTime.vue?vue&type=style&index=0&id=640bf49a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640bf49a",
  null
  
)

export default component.exports